import { render, staticRenderFns } from "./platformCoupon.vue?vue&type=template&id=4cc0f5b9&"
import script from "./platformCoupon.vue?vue&type=script&lang=js&"
export * from "./platformCoupon.vue?vue&type=script&lang=js&"
import style0 from "./platformCoupon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports